import { getRailsClient } from "sj-ui-toolkit/src/client";

export interface Lesson {
  id?: string;
  label?: string;
  lessonKey?: string;
  lesson_key?: string;
  title?: string;
  name?: string;
  duration?: number | string;
  description?: string;
  topicName?: string;
  topicSlug?: string;
  required?: boolean;
}

export const loadAllLessons = async (): Promise<{ lessons: Lesson[]; error?: string }> => {
  try {
    const { data } = await getRailsClient().get<{ lessons?: Lesson[] }>(
      "/api/internal_api/v1/admin/lessons"
    );
    return { lessons: data?.lessons ?? [] };
  } catch (err) {
    const error = err instanceof Error ? err.message : "Failed to load lessons";
    return { lessons: [], error };
  }
};
